import React, { FC, useState } from 'react';
import UsersList from '../../features/user/UsersList';
import { useAppDispatch, useAppSelector } from '../../hooks/defaultHooks';
import { getIsAtLeastAdmin } from '../../selectors/selectors';
import routes from '../../routes';
import { convertBinaryToLink } from '../../utils/converBinaryToLink';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import cls from './UsersPage.module.scss';
import { openModal } from '../../store/slices/modalSlice';
import DownloadReportsButton from '../../UIComponents/DownloadReportsButton/DownloadReportsButton';

const UsersPage: FC = () => {
  const [page, setPage] = useState<number>(0);
  const [exportsPage, setExportsPage] = useState<number>(0);
  const isAtLeastAdmin = useAppSelector(getIsAtLeastAdmin);
  const dispatch = useAppDispatch();
  const exportsSize = 11000;

  const downloadUsersHandler = () => {
    const download = `${routes.api.basePath()}${routes.api.usersLogsExport()}`;
    convertBinaryToLink(download, {
      page: exportsPage,
      size: exportsSize,
    });
  };
  const openDownloadModalHandler = () => {
    dispatch(
      openModal({
        type: 'downloadReportsModal',
        extra: { title: 'employees', handler: downloadUsersHandler },
      }),
    );
  };
  useDocumentTitle('Employees');
  return (
    <div className={`${cls.Page} grid-container`}>
      <div className={cls.Header}>
        <h1 className={cls.Title}>Employees</h1>
      </div>
      <div className={cls.Panel}>
        {isAtLeastAdmin && <DownloadReportsButton clickHandler={openDownloadModalHandler} />}
      </div>
      <UsersList
        page={page}
        setPage={setPage}
        exportsPage={exportsPage}
        exportsSize={exportsSize}
        setExportsPage={setExportsPage}
        className={cls.List}
      />
    </div>
  );
};
export default UsersPage;
